"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgPressureHighFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("defs", null,
            React.createElement("style", null, '.pressure-high_filled_svg__cls-1{display:none}')),
        React.createElement("g", { id: "pressure-high_filled_svg__transparent_box" },
            React.createElement("path", { className: "pressure-high_filled_svg__cls-1", d: "M0 0h32v32H0z" }),
            React.createElement("path", { className: "pressure-high_filled_svg__cls-1", d: "M0 0h32v32H0z" })),
        React.createElement("g", { id: "pressure-high_filled_svg__FILLED" },
            React.createElement("path", { d: "M6 28h20v2H6zM15 23H6v2h20v-2h-9v-2a10 10 0 10-2 0zm-.56-13.56a2.23 2.23 0 013.12 0 2.19 2.19 0 01.52 2.23l2.16 2.16-1.41 1.41-2.16-2.16a2.19 2.19 0 01-2.23-.52 2.23 2.23 0 010-3.12z" }))));
}
exports.default = SvgPressureHighFilled;
//# sourceMappingURL=PressureHighFilled.js.map